import $thousandMask from "@/mixins/thousandMask";
export default {
  name: "prices-and-iso-in-table",
  components: {},
  mixins: [$thousandMask],
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
